import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  id: "prefix__Livello_1",
  x: "0",
  y: "0",
  version: "1.1",
  viewBox: "0 0 100 100"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createTextVNode(".prefix__st0{fill:#e59500}", -1)
      ]))]),
      _: 1
    })),
    _cache[1] || (_cache[1] = _createElementVNode("switch", null, [
      _createElementVNode("g", null, [
        _createElementVNode("path", {
          d: "M28.84 46.62v10.44c0 2.39-1.26 4.66-3.39 5.84l-5.02 2.9c-2.29 1.37-3.04 4.35-1.57 6.62 1.43 2.11 4.27 2.7 6.49 1.44l4.9-2.83c4.98-2.9 8.1-8.24 8.09-14l-.08-33.57c0-4.11 2.21-7.92 5.76-9.96 1.78-.98 3.76-1.49 5.77-1.49 6.37-.01 11.55 5.12 11.56 11.43v2.18c0 2.53 1.36 4.86 3.55 6.11l5.98 3.42V23.71c0-3.8-1.04-7.39-2.82-10.48C64.42 6.94 57.57 2.68 49.82 2.69c-3.68 0-7.32.96-10.48 2.82-6.52 3.72-10.51 10.73-10.5 18.21z",
          class: "prefix__st0"
        }),
        _createElementVNode("path", {
          d: "m44.19 82.5 18.6-10.68a.2.2 0 0 0 .06-.04c2.66-1.44 5.88-1.36 8.51.15l3.22 1.85c2.3 1.33 5.18.58 6.48-1.69s.55-5.13-1.75-6.42l-5.03-2.89a16.28 16.28 0 0 0-16.26.02L28.77 79.6a11.47 11.47 0 0 1-11.55.01c-1.74-.98-3.25-2.43-4.24-4.15-3.21-5.44-1.36-12.46 4.18-15.64l1.44-.83a7 7 0 0 0 3.52-6.08v-6.29c-.09.05-.18.11-.27.16l-9.45 5.43a20.8 20.8 0 0 0-7.62 7.68 21.1 21.1 0 0 0 .02 21.08c1.82 3.24 4.52 5.89 7.68 7.66a21.06 21.06 0 0 0 21.04-.02z",
          class: "prefix__st0"
        }),
        _createElementVNode("path", {
          d: "m87.45 52.24-9.46-5.49-19.88-11.37a7.05 7.05 0 0 1-3.55-6.12h.01c0-.05-.01-.11-.01-.16l-.01-5.8c-.04-2.59-2.1-4.7-4.75-4.7-2.57.04-4.7 2.08-4.7 4.71l.01 5.8c.01 5.76 3.14 11.08 8.16 13.98L82.63 59.9c3.56 2.03 5.82 5.83 5.82 9.91.04 2-.51 4-1.5 5.72-3.16 5.45-10.4 7.38-16.06 4.01a7.69 7.69 0 0 0-7.6 0l-6.3 3.59 9.46 5.49c3.36 1.9 6.96 2.8 10.52 2.8 7.28-.01 14.31-3.77 18.22-10.42 1.86-3.21 2.8-6.84 2.8-10.52-.01-7.49-4.05-14.49-10.54-18.24",
          class: "prefix__st0"
        })
      ])
    ], -1))
  ]))
}
export default { render: render }